<template>
  <div>
    <v-row>
      <LMap
        v-if="plan !== undefined"
        style="height: 600px; width: 100%;"
        :crs="crs"
        :zoom="zoom"
        :center="center"
        :options="options"
        ref="map"
      >
        <LTileLayer :url="url" noWrap :minZoom="plan.minzoom" :maxZoom="plan.maxzoom"></LTileLayer>

        <LFeatureGroup name="people" :visible="peopleLayer">
          <LCircleMarker :key="index" :lat-lng="xylocation.position" :colour="black" :fillColor="black"
                         :fillOpacity="1"
                         :weight='0' :radius="xyRadius" v-for="(xylocation, index) in xyMarkerData">
          </LCircleMarker>
        </LFeatureGroup>

        <LFeatureGroup name="managedSpaces" :visible="spaceLayer">
          <div :key="index" v-for="(managedSpaceMarker, index) in managedSpaceMarkers">
            <LCircleMarker :lat-lng="managedSpaceMarker.location" :color="managedSpaceMarker.colour"
                           :fillColor="managedSpaceMarker.colour"
                           :radius="radius" v-if="managedSpaceMarker.shown === true">
              <LPopup>
                <div v-if="managedSpaceMarker.name" class="largepopup">
                  <strong font-size=30> {{ managedSpaceMarker.name }} </strong><br>
                </div>
                <br>
                <div v-if="managedSpaceMarker.sensor.time_utc" class="popup">
                  <div v-if="managedSpaceMarker.occupancy !== null" class="popup">
                    Occupancy: {{ managedSpaceMarker.sensor.occupancy }} <br>
                  </div>
                  <div v-if="managedSpaceMarker.occupancy === null" class="popup">
                    Occupancy: - <br>
                  </div>
                  <div v-if="managedSpaceMarker.colour" class="popup">
                    Status: {{ status(managedSpaceMarker.colour) }} <br>
                  </div>
                  <!-- Current Air Quality Rating: <br>
                  Current Sound Level Rating: <br>
                  Current Climate Rating: <br> -->
                  <div v-if="managedSpaceMarker.sensor.temperature" class="popup">
                    Current Temperature: {{ roundedTemp(managedSpaceMarker.sensor.temperature) }} <br>
                  </div>
                  <div class="popup">
                    Time Last Occupied: {{ unixToDate(managedSpaceMarker.sensor.timeLastOccupied) }} <br>
                  </div>
                </div>
                <div v-if="!managedSpaceMarker.sensor.time_utc" class="popup">
                  No data yet<br>
                </div>

                <!-- <hr>
                Occupancy % Used Today <br>
                Frequency % Used Today <br>
                Utilisation % Used Today <br> -->
                <div v-if="isStaff" class="popup">
                  <br>
                  <hr>
                  <br>
                  Managed Space ID: <br> {{ managedSpaceMarker.id }}
                </div>
                <div>
                  <br>
                  <v-col style="text-align: left;">
                    <v-btn
                      v-if="isBookable(managedSpaceMarker)"
                      :style="{
            backgroundColor : 'blue !important',
            color: 'white !important'}"
                      class="layer-btn2"
                      large tile depressed
                      width="200"
                      @click="openWindow(managedSpaceMarker.id)"
                    >Book Now
                    </v-btn>
                  </v-col>
                </div>
              </LPopup>
            </LCircleMarker>
          </div>
        </LFeatureGroup>

        <LFeatureGroup name="sensors" :visible="sensorLayer !== false">
          <div :key="index" v-for="(sensor, index) in sensorMarkers">
            <v-rotated-marker :lat-lng="sensor.location" :rotationAngle="getAngle(sensor.sensorLocation.sensorrotation)"
                              :icon="getIcon(sensorLayer, sensor)" v-if="sensor.sensorLocation.shown === true">

              <!-- TODO hot fixed bug that sensor detail can be null if sensor has never sent any data however some significant rationalisation of popup recommended -->

              <div v-if="!sensor.detail">
                <LPopup>
                  <div class='largepopup'>
                    {{ sensor.sensorLocation.name }}<br>
                    <br>
                  </div>
                  <div class='popup'>
                    Last Reading: No data yet <br>
                    <div v-if="isStaff">
                      Map Marker: {{ sensor.sensorLocation.mapmarkerlabel }}<br>
                      Sensor Height: {{ sensor.sensorLocation.sensorheight }} m<br>
                      Sensor Rotation: {{ sensor.sensorLocation.sensorrotation }} °<br>
                    </div>
                  </div>
                </LPopup>
              </div>

              <div v-if="sensor.detail">
                <LPopup :options='leafletOptions' v-if='sensor.detail.devicetype >= 8'>
                  <div class="row">
                    <div class="column">
                      <div class='largepopup'>
                        {{ sensor.sensorLocation.name }} <br>
                      </div>
                      <br>
                      <div class='popup'>
                        <div class='popupheading'>
                          Air Quality and Ventilation<br>
                        </div>
                        <div v-if="sensor.detail.aqi2 !== null">
                          AQI: {{ sensor.detail.aqi2 }} ppm<br>
                        </div>
                        <div v-if="sensor.detail.aqi2 === null">
                          AQI: <br>
                        </div>
                        <div v-if="sensor.detail.rawgasbme !== null">
                          VOC: {{ sensor.detail.rawgasbme }} ppm<br>
                        </div>
                        <div v-if="sensor.detail.rawgasbme === null">
                          VOC: <br>
                        </div>
                        <div v-if="sensor.detail.co2hq !== null">
                          CO2: {{ sensor.detail.co2hq }} ppm<br>
                        </div>
                        <div v-if="sensor.detail.co2hq === null">
                          CO2: <br>
                        </div>
                        <br>
                        <div class='popupheading'>
                          Thermal Comfort<br>
                        </div>
                        <div v-if="sensor.detail.temperature !== null">
                          Temperature: {{ sensor.detail.temperature }} °C<br>
                        </div>
                        <div v-if="sensor.detail.temperature === null">
                          Temperature: <br>
                        </div>
                        <div v-if="sensor.detail.humid !== null">
                          Relative Humidity: {{ sensor.detail.humid }} °C<br>
                        </div>
                        <div v-if="sensor.detail.humid === null">
                          Relative Humidity: <br>
                        </div>
                        <div v-if="sensor.detail.pressure !== null">
                          Pressure: {{ sensor.detail.pressure }} hPa<br>
                        </div>
                        <div v-if="sensor.detail.pressure === null">
                          Pressure: <br>
                        </div>
                        <br>
                        <div class='popupheading'>
                          Lighting and Daylighting<br>
                        </div>
                        <div v-if="sensor.detail.lux !== null">
                          Illuminance: {{ sensor.detail.lux }} lux<br>
                        </div>
                        <div v-if="sensor.detail.lux === null">
                          Illuminance: <br>
                        </div>
                        <br>
                      </div>
                    </div>
                    <div class="column">
                      <div class='popup'>
                        <div class='popupheading'>
                          Noise and Acoustics<br>
                        </div>
                        <div v-if="sensor.detail.noise !== null">
                          Indoor Sound Level: {{ sensor.detail.noise }} dB<br>
                        </div>
                        <div v-if="sensor.detail.noise === null">
                          Indoor Sound Level: <br>
                        </div>
                        <br>
                        <div class='popupheading'>
                          Office Layout and Occupancy<br>
                        </div>
                        <div v-if="sensor.detail.occupancy !== null">
                          Current Occupancy: {{ sensor.detail.occupancy }} people<br>
                        </div>
                        <div v-if="sensor.detail.occupancy === null">
                          Current Occupancy: <br>
                        </div>
                        <div v-if="sensor.detail.countin !== null">
                          People In: {{ sensor.detail.countin }} <br>
                        </div>
                        <div v-if="sensor.detail.countout !== null">
                          People Out: {{ sensor.detail.countout }} <br>
                        </div>
                        <br>
                        <div class='popupheading'>
                          Sensor Details<br>
                        </div>
                        Last Reading: {{ formatDate(sensor.detail.time_utc) }} <br>
                        <div v-if="isStaff">
                          Map Marker: {{ sensor.sensorLocation.mapmarkerlabel }}<br>
                          Sensor Height: {{ sensor.sensorLocation.sensorheight }} m<br>
                          Sensor Rotation: {{ sensor.sensorLocation.sensorrotation }} °<br>
                          Device Type: {{ getType(sensor.detail.devicetype) }}<br>
                          Sensor Bearing: {{ sensor.detail.bearing }}°<br>
                          Internal Humidity: {{ sensor.detail.internalhumid }}%<br>
                          Internal Temperature: {{ sensor.detail.internaltemperature }}°C<br>
                        </div>
                      </div>
                    </div>
                  </div>
                </LPopup>
              </div>

              <div v-if="sensor.detail">
                <LPopup v-if='sensor.detail.devicetype <= 7'>
                  <div class='largepopup'>
                    {{ sensor.sensorLocation.name }}<br>
                    <br>
                    <div v-if="sensor.detail">
                      <div v-if="sensor.detail.devicetype <= 7" class='popup'>
                        <div v-if="sensor.detail.occupancy !== null">
                          Occupancy: {{ sensor.detail.occupancy }} people<br>
                        </div>
                        <div v-if="sensor.detail.occupancy === null">
                          Occupancy: - <br>
                        </div>
                        <div v-if="sensor.detail.countin !== null">
                          People In: {{ sensor.detail.countin }} <br>
                        </div>
                        <div v-if="sensor.detail.countout !== null">
                          People Out: {{ sensor.detail.countout }} <br>
                        </div>
                        <div v-if="sensor.detail.temperature !== null">
                          Temperature: {{ roundedTemp(sensor.detail.temperature) }}<br>
                        </div>
                        <div v-if="sensor.detail.temperature === null">
                          Temperature: - <br>
                        </div>
                        <div v-if="sensor.detail.humid !== null">
                          Humidity: {{ sensor.detail.humid }} %<br>
                        </div>
                        <div v-if="sensor.detail.humid === null">
                          Humidity: - <br>
                        </div>
                        <div v-if="sensor.detail.pressure !== null">
                          Pressure: {{ sensor.detail.pressure }} mb<br>
                        </div>
                        <div v-if="sensor.detail.pressure === null">
                          Pressure: - <br>
                        </div>
                        <div v-if="sensor.detail.noise !== null">
                          Sound Level: {{ sensor.detail.noise }} dB<br>
                        </div>
                        <div v-if="sensor.detail.noise === null">
                          Sound Level: - <br>
                        </div>
                        <div v-if="sensor.detail.lux !== null">
                          Light Level: {{ sensor.detail.lux }} lux<br>
                        </div>
                        <div v-if="sensor.detail.lux  === null">
                          Light Level: - <br>
                        </div>
                        <div v-if="sensor.detail.co2 !== null">
                          CO2: {{ sensor.detail.co2 }} ppm<br>
                        </div>
                        <div v-if="sensor.detail.co2 === null">
                          CO2: - <br>
                        </div>
                        <div v-if="sensor.detail.voc !== null">
                          VOC: {{ sensor.detail.voc }} ppm<br>
                        </div>
                        <div v-if="sensor.detail.voc === null">
                          VOC: - <br>
                        </div>
                        <br>
                        <hr>
                        <br>
                        Last Reading: {{ formatDate(sensor.detail.time_utc) }} <br>
                        <br>
                        <hr>
                        <br>
                        <div v-if="isStaff" class='popup'>
                          Map Marker: {{ sensor.sensorLocation.mapmarkerlabel }}<br>
                          Sensor Height: {{ sensor.sensorLocation.sensorheight }} m<br>
                          Sensor Rotation: {{ sensor.sensorLocation.sensorrotation }} °<br>
                          Device Type: {{ getType(sensor.detail.devicetype) }}<br>
                          Sensor Bearing: {{ sensor.detail.bearing }}°<br>
                          Internal Humidity: {{ sensor.detail.internalhumid }}%<br>
                          Internal Temperature: {{ sensor.detail.internaltemperature }}°C<br>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div>
                  <div class="column" v-if="sensor.detail.devicetype >= 8">
                      <div class='popupheading'>
                        Sensor Details<br>
                      </div>
                  <div v-if="!sensor.detail" class='popup'>
                    Last Reading: No data yet <br>
                  </div>
                  <div v-if="sensor.detail" class='popup'>
                    Last Reading: {{ formatDate(sensor.detail.time_utc) }} <br>
                  </div>
                  <div v-if="isStaff" class='popup'>
                    Map Marker: {{ sensor.sensorLocation.mapmarkerlabel }}<br>
                    Sensor Height: {{ sensor.sensorLocation.sensorheight }} m<br>
                    Sensor Rotation: {{ sensor.sensorLocation.sensorrotation }} °<br>
                    <div v-if="sensor.detail">
                      Device Type: {{ getType(sensor.detail.devicetype) }}<br>
                      Sensor Bearing: {{ sensor.detail.bearing }}°<br>
                      Internal Humidity: {{ sensor.detail.internalhumid }}%<br>
                      Internal Temperature: {{ sensor.detail.internaltemperature }}°C<br>
                    </div>
                  </div>
                  </div>
                  </div> -->
                </LPopup>
              </div>

            </v-rotated-marker>
          </div>
        </LFeatureGroup>
        <Heatmap v-if="environmentLayer !== false ? true : false" :latLng="environmentPoints"></Heatmap>
      </LMap>
    </v-row>

    <v-row>

      <v-col cols="10">
      </v-col>
      <v-col cols="1">
        <v-btn class="zoomBtn" tile depressed x-large @click="zoomIn">+</v-btn>
      </v-col>
      <v-col cols="1">
        <v-btn class="zoomBtn" tile depressed x-large @click="zoomOut">-</v-btn>
      </v-col>
    </v-row>

    <div v-if="debug">
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title>Debug Building</v-card-title>
            <!-- <p>Building {{ building }}</p> -->
            <!-- <p>Plan {{ plan }}</p> -->
            <p>People layer {{ peopleLayer }}</p>
            <p>Space layer {{ spaceLayer }}</p>
            <p>Sensor layer {{ sensorLayer }}</p>
            <!-- <p>X Y MarkerData {{ xyMarkerData }} </p> -->
            <!-- <p>Zoom {{ zoom }} </p> -->
            <!-- <p>Selected Plan: {{ plan }}</p> -->
            <!-- <p>Sensor Markers {{ sensorMarkers[0] }}</p> -->
            <p>Managed space markers {{ managedSpaceMarkers }}</p>
            <!-- <p>Plan Managed Spaces With Readings: {{ managedSpaces }}</p> -->
            <!-- <p>Sensor readings for building: {{ sensorReadings }}</p> -->
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import L from 'leaflet'
import { LCircleMarker, LFeatureGroup, LMap, LTileLayer, LPopup } from 'vue2-leaflet'
import Heatmap from './Heatmap'
import createSimpleCrs from '../util/crs'
import { mapState } from 'vuex'
import config from '../config/config'
import moment from 'moment'
import Vue2LeafletRotatedMarker from 'vue2-leaflet-rotatedmarker'
import { generateXYMarkerData } from '../lib/xyperson'
import { generateEnvironmentPoints, generateManagedSpaceMarkers, generateSensorMarkers } from '@/lib/mapMarkers'

let sensorIconOk = L.icon({ iconUrl: require('../assets/sensor_icons_128p/sensor_ok.png'), iconSize: [22, 22] })
// let sensorIconWarn =  L.icon({ iconUrl: require('../assets/sensor_icons_128p/sensor_warning.png'), iconSize: [22, 22]})
let sensorIconWarnNoDataEver = L.icon({
  iconUrl: require('../assets/sensor_icons_128p/no_sensor_allocated.png'),
  iconSize: [22, 22]
})
let sensorIconWarn1h = L.icon({
  iconUrl: require('../assets/sensor_icons_128p/sensor_no_data_1_hour.png'),
  iconSize: [22, 22]
})
let sensorIconWarn1d = L.icon({
  iconUrl: require('../assets/sensor_icons_128p/sensor_no_data_1_day.png'),
  iconSize: [22, 22]
})
let sensorIconWarn10m = L.icon({
  iconUrl: require('../assets/sensor_icons_128p/sensor_no_data_10_mins.png'),
  iconSize: [22, 22]
})
let sensorIconRed2d = L.icon({
  iconUrl: require('../assets/sensor_icons_128p/sensor_failure.png'),
  iconSize: [22, 22]
})
let sensorIconFlow = L.icon({ iconUrl: require('../assets/sensor_icons_128p/sensor_flow.png'), iconSize: [22, 22] })
let sensorIconHx1 = L.icon({ iconUrl: require('../assets/sensor_icons_128p/sensor_hx1.png'), iconSize: [22, 22] })
let sensorIconHx2 = L.icon({ iconUrl: require('../assets/sensor_icons_128p/sensor_hx2.png'), iconSize: [22, 22] })
let sensorIconClear = L.icon({ iconUrl: require('../assets/sensor_icons_128p/sensor_clear.png'), iconSize: [22, 22] })

function getAngle (angle) {
  return (angle + 180) % 360
}

function getIcon (layer, latestData) {
  // return Math.round((now - latestData) / 1000.0) <= config.maxDisplayDataAgeSec
  // .detail.time_epoch_milli
  let now = new Date().getTime()
  switch (layer) {
    case 'Sensor Status':
      if (!latestData.detail) {
        return sensorIconWarnNoDataEver
      } else if ((now - latestData.detail.time_epoch_milli) >= 15120000) {
        // console.log(latestData)
        return sensorIconRed2d
      } else if ((now - latestData.detail.time_epoch_milli) >= 86400000) {
        return sensorIconWarn1d
      } else if ((now - latestData.detail.time_epoch_milli) >= 3600000) {
        return sensorIconWarn1h
      } else if ((now - latestData.detail.time_epoch_milli) >= 600000) {
        return sensorIconWarn10m
      } else {
        return sensorIconOk
      }
    case 'Sensor Type':
      if (!latestData.detail) {
        return sensorIconWarnNoDataEver
      } else if (latestData.detail.countin !== null || latestData.detail.countout !== null) {
        return sensorIconFlow
      } else if (latestData.detail.devicetype >= 8) {
        return sensorIconHx2
      } else {
        return sensorIconHx1
      }
  }
  return sensorIconClear
  // if (Math.round((now - latestData) / 1000.0) <= config.maxDisplayDataAgeSec) {
  //   return this.sensorIconOk
  // } else {
  //   return this.sensorIconWarn
  // }
}

export default {
  name: 'spacemap',
  components: {
    LMap,
    LTileLayer,
    LCircleMarker,
    LFeatureGroup,
    LPopup,
    Heatmap,
    'v-rotated-marker': Vue2LeafletRotatedMarker
  },
  props: ['building', 'sensorReadings', 'managedSpaces', 'plan', 'sensorLayer', 'spaceLayer', 'occupancyLayer', 'peopleLayer', 'environmentLayer'],
  data: function () {
    return {
      debug: false,
      zoom: 3,
      crs: createSimpleCrs(this.plan.maxzoom, this.plan.pixeltometre),
      center: L.latLng(-this.plan.planheightpx / 2, this.plan.planwidthpx / 2),
      radius: 10,
      smallRadius: 2.5,
      leafletOptions: {
        minWidth: 430,
        maxHeight: 350
      },
      iconSizes: [3, 3, 4, 4, 6, 8],
      iconSizePxl: 64,
      // sensorIcon: L.icon({ iconUrl: require('../assets/sensorIcon.png'), iconSize: [24, 27] }),
      positionIcon: L.icon({ iconUrl: require('../assets/positionsdot.png'), iconSize: [24, 27] }),
      colours: {
        occupied: '#ff200c',
        unoccupied: '#00ee8d',
        available: '#00ffff'
      },
      black: '#000000',
      options: {
        attributionControl: false,
        zoomControl: false,
        scrollWheelZoom: false,
        tap: false // Fix popup on Safari: https://github.com/Leaflet/Leaflet/issues/7255#issuecomment-849638476
      }
    }
  },
  computed: mapState({
    url: function () {
      return (config.mapBaseURL + 'tiles/' + this.plan.planurl + '{z}/{x}/{y}.png')
    },
    isStaff: state => state.auth.isStaff,
    kiosk: state => state.auth.kiosk,
    callback: state => state.auth.bookingCallback,
    managedSpaceMarkers: function () {
      // return generateManagedSpaceMarkers(this.building, this.managedSpaces, this.colours)
      // console.log(this.managedSpaces)
      if (this.kiosk === 10) {
        let dataToReturn = []
        let returnedData = generateManagedSpaceMarkers(this.building, this.managedSpaces, this.colours)
        returnedData.forEach(data => {
          data.managedspacegrouphasmanagedspace_set.forEach(element => {
            if (element.managedspacegroup.name === 'Bookable') {
              dataToReturn.push(data)
            }
          })
        })
        // console.log(dataToReturn)
        return dataToReturn
      } else {
        // console.log(generateManagedSpaceMarkers(this.building, this.managedSpaces, this.colours))
        return generateManagedSpaceMarkers(this.building, this.managedSpaces, this.colours)
      }
    },
    sensorMarkers: function () {
      // console.log(generateSensorMarkers(this.building, this.plan, this.sensorReadings))
      return generateSensorMarkers(this.building, this.plan, this.sensorReadings)
    },
    xyRadius: function () {
      let roundedZoom = Math.round(this.zoom)
      if ((roundedZoom <= 5) && (roundedZoom >= 0)) {
        this.iconSizePxl = this.iconSizes[roundedZoom]
      }
      return this.iconSizePxl
    },
    environmentPoints: function () {
      return generateEnvironmentPoints(this.building, this.plan, this.sensorReadings, this.environmentLayer)
    },
    xyMarkerData: function () {
      return generateXYMarkerData(this.building, this.sensorReadings, this.plan, this.isStaff)
    }
  }),
  methods: {
    zoomIn () {
      if (this.zoom < 5) {
        this.zoom++
        if (this.smallRadius > 3.75) {
          this.smallRadius = this.smallRadius / 1.5
        }
        this.$refs.map.mapObject.zoomIn()
      }
    },
    getIcon (layer, latestData) {
      let icon = getIcon(layer, latestData)
      // console.log('Icon', icon)
      return icon
    },
    getAngle (angle) {
      let flipAngle = getAngle(angle)
      return flipAngle
    },
    showIf (managedspace) {
      if (this.kiosk !== 10) {
        return true
      } else {
        let bool = false
        managedspace.managedspacegrouphasmanagedspace_set.forEach(element => {
          if (element.managedspacegroup.name === 'Bookable') {
            bool = true
          }
        })
        return bool
      }
    },
    isBookable (managedspace) {
      let bool = false
      managedspace.managedspacegrouphasmanagedspace_set.forEach(element => {
        if (element.managedspacegroup.name === 'Bookable' && this.kiosk === 10) {
          bool = true
        }
      })
      return bool
    },
    zoomOut () {
      if (this.zoom > 0) {
        this.zoom--
        if (this.smallRadius < 3.75) {
          this.smallRadius = this.smallRadius * 1.5
        }
        this.$refs.map.mapObject.zoomOut()
      }
    },
    unixToDate: function (unixTimestamp) {
      let date = new Date(unixTimestamp)
      return moment(date).format('HH:mm DD/M/YYYY')
    },
    roundedTemp: function (temp) {
      if (temp === undefined) {
        return ''
      }
      return temp.toFixed(1).toString() + ' °C'
    },
    openWindow: function (id) {
      // window.open(`https://${this.callback}/Web/reservation.php?rid=${id}`, '_blank')
      // console.log('' + this.callback + '/reservation.php?rid=' + id)
      // window.open('' + this.callback + '/reservation.php?rid=' + id, '_blank')
      // return '' + this.callback + '/reservation.php?rid=' + id, '_blank'
      window.location.href = '' + this.callback + '/reservation.php?rid=' + id
      // window.open(`${this.callback}`, '_blank')
    },
    status: function (colour) {
      // console.log(this.managedSpaceMarkers);
      if (colour === '#ff200c') {
        return 'Occupied'
      } else if (colour === '#00ff00') {
        return 'Unoccupied'
      } else if (colour === '#00ee8d') {
        return 'Available'
      }
    },
    formatDate: function (date) {
      return moment(date).format('D/M/YYYY HH:mm')
    },
    getType: function (typeNum) {
      if (typeNum > 7) {
        return 'HX2'
      } else {
        return 'HX1 or Less'
      }
    }
  }
}
</script>

<!--suppress CssInvalidPropertyValue -->
<style>
.leaflet-container {
  background-color: rgba(255, 0, 0, 0.0);
}

.zoomBtn > .v-btn__content {
  font-size: 40px;
}

.popup {
  font-size: 13px;
  font-family: 'NeutrifPro-Light', serif;
}

.popupheading {
  font-size: 13px;
  font-family: 'NeutrifPro-Bold', serif;
  text-decoration: underline;
}

.largepopup {
  font-size: 18px;
  font-family: 'NeutrifPro-Bold', serif;
}

.layer-btn {
  margin-right: 10px;
  font-family: 'NeutrifPro-Bold', serif;
  font-size: 10px;
  letter-spacing: 3px;
}

.layer-btn2 {
  align-items: left;
  font-family: 'NeutrifPro-Bold', serif;
  font-size: 10px;
  letter-spacing: 3px;
}

* {
  box-sizing: border-box;
}

/* Create two equal columns that floats next to each other */
.column {
  float: left;
  width: 50%;
  padding: 10px;
}

/* Clear floats after the columns */
.row:after {
  content: "";
  display: table;
  clear: both;
}

hr {
  width: 50%;
  margin: 0 auto;
  margin-left: 0;
}

</style>
